<div class="ui-user-menu">
  <div class="ui-user-menu__info">
    <div class="ui-user-menu__name">{{ userName }}</div>
    <div class="ui-user-menu__company" *ngIf="companyName">{{ companyName }}</div>
  </div>
  <div class="ui-user-menu__avatar">{{ initials }}</div>
  <button class="ui-user-menu__logout" type="button" (click)="onLogout()" title="Logout">
    <mat-icon>logout</mat-icon>
  </button>
</div>
